import { ServiceUrlsService } from '../../common-service/service-urls/service-urls.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class PremiumPlanService {

  constructor(private httpClient: HttpClient,
              private serviceUrls: ServiceUrlsService) { }

  subscribePremiumplan(premiumPlanObject): Observable<any> {
      return this.httpClient.post(this.serviceUrls.subscribePremiumPlan, premiumPlanObject);
  }

  applyCouponCode(applyVoucherObject): Observable<any> {
      return this.httpClient.post(this.serviceUrls.applyVoucherCodeURL, applyVoucherObject);
  }

}



// WEBPACK FOOTER //
// ./src/app/plans/service/premium-plan.service.ts